module.exports = __webpack_public_path__ + "static/media/back.6bf21831.png";